import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from 'core/api/queryKeys';
import { humanizeApiError } from 'core/errors/mapFieldErrors';
import { useI18n } from 'core/i18n/I18nProvider';
import { userApi } from 'features/home/home.api';
import { ErrorState, Skeleton } from 'shared/components/Feedback';
import { PageMeta } from 'shared/components/PageMeta';
import { ResultPresentation } from 'shared/components/ResultPresentation';

export function ResultPage() {
  const { attemptId } = useParams();
  const { t } = useI18n();
  const query = useQuery({
    queryKey: queryKeys.result(attemptId),
    queryFn: () => userApi.result(attemptId),
  });
  const homeQuery = useQuery({
    queryKey: queryKeys.home,
    queryFn: () => userApi.home(),
    refetchOnWindowFocus: 'always',
    refetchOnReconnect: 'always',
  });

  if (query.isLoading) {
    return <Skeleton rows={8} />;
  }
  if (query.isError) {
    return <ErrorState title={humanizeApiError(query.error, t)} onRetry={() => query.refetch()} retryLabel={t('actions.retry')} />;
  }

  return (
    <div>
      <PageMeta titleKey="meta.result" />
      <ResultPresentation result={query.data} home={homeQuery.data} />
    </div>
  );
}
